import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-menu-list-item-nav',
  templateUrl: './menu-list-item-nav.component.html',
  styleUrls: ['./menu-list-item-nav.component.scss'],
  standalone: false
})
export class MenuListItemNavComponent {
  @Input() public routerLink = "";
  @Input() public icon = "";
  @Input() public itemtrans = "";
}
